import COLORS from './colors.js';

const COLOR_VARIANT = {
    green: {
        primary: COLORS.GREEN_600,
        secondary: COLORS.GREEN_200,
    },
    orange: {
        primary: COLORS.ORANGE_500,
        secondary: COLORS.ORANGE_100,
    },
    red: {
        primary: COLORS.RED,
        secondary: COLORS.RED_100,
    },
    purple: {
        primary: COLORS.PURPLE,
        secondary: COLORS.PURPLE_LIGHT,
    },
    grey: {
        primary: COLORS.GREY_600,
        secondary: COLORS.GREY_200,
    },
    blue: {
        primary: COLORS.BLUE,
        secondary: COLORS.BLUE_100,
    },
};

export { COLOR_VARIANT };
//# sourceMappingURL=color-variant.js.map
